const RU = {
  'identity.tab.card': 'Карточка клиента',

  'identity.card.pick': 'Клиент',
  'identity.card.pickHint': 'Найдите по телефону или по номеру автомобиля',
  'identity.card.none': 'Клиент не выбран',
  'identity.card.noneReason':
    'Карточка собирает историю клиента по всей сети: контакты, автомобили, визиты, покупки, подписку, бонусы, обращения и согласия. Начните с поиска.',
  'identity.card.profile': 'Профиль',
  'identity.card.history': 'История изменений',
  'identity.card.noName': 'Без имени',
  'identity.card.phone': 'Телефон',
  'identity.card.status': 'Статус',
  'identity.card.copyLink': 'Скопировать ссылку',
  'identity.card.another': 'Другой клиент',
  'identity.card.linkCopied': 'Ссылка на карточку скопирована',

  'identity.card.loyalty': 'Лояльность',
  'identity.card.tier': 'Уровень',
  'identity.card.noTier': 'Уровень не присвоен',
  'identity.card.nextTier': 'До уровня «{name}»',
  'identity.card.needVisits': 'визитов: {n}',
  'identity.card.needSpend': 'трат: {sum}',
  'identity.card.needAccrued': 'начислений: {sum}',
  'identity.card.balance': 'Баланс',
  'identity.card.materialized': 'Материализованный',
  'identity.card.drift': 'Расхождение',
  'identity.card.noAccount': 'Бонусный счёт ещё не заведён — начислений не было',
  'identity.card.offers': 'Что предложить',
  'identity.card.noOffers': 'Подходящих правил сейчас нет',

  'identity.card.subscriptions': 'Подписка',
  'identity.card.plan': 'План',
  'identity.card.period': 'Период',
  'identity.card.until': 'Оплачен до',
  'identity.card.autorenew': 'Автопродление',
  'identity.card.autorenewOn': 'включено',
  'identity.card.autorenewOff': 'выключено',
  'identity.card.noSubscriptions': 'Подписки нет',
  'identity.card.noSubscriptionsReason': 'Клиент платит за каждую мойку отдельно.',

  'identity.card.vehicles': 'Автомобили',
  'identity.card.plate': 'Номер',
  'identity.card.role': 'Роль',
  'identity.card.since': 'С',
  'identity.card.till': 'По',
  'identity.card.noVehicles': 'Автомобиль не привязан',
  'identity.card.noVehiclesReason':
    'Без привязки к автомобилю клиент не узнаётся на въезде — это главный ключ идентификации.',

  'identity.card.visits': 'Визиты',
  'identity.card.visitAt': 'Когда',
  'identity.card.site': 'Объект',
  'identity.card.method': 'Как опознан',
  'identity.method.lpr': 'По номеру',
  'identity.method.manual': 'Ввёл оператор',
  'identity.method.phone': 'По телефону',
  'identity.method.declined': 'Клиент отказался',
  'identity.method.pending': 'Не опознан',
  'identity.card.siteUnknown': 'Объект не найден',

  'identity.visit.title': 'Визит',
  'identity.visit.hint': 'Нажмите на визит в списке, чтобы открыть карточку',
  'identity.visit.close': 'Закрыть',
  'identity.visit.entered': 'Въезд',
  'identity.visit.started': 'Старт мойки',
  'identity.visit.exited': 'Выезд',
  'identity.visit.entrySpeed': 'От въезда до старта',
  'identity.visit.cycle': 'Время цикла',
  'identity.visit.exitSource.lpr': 'камера выезда',
  'identity.visit.exitSource.operator': 'кнопка «Готово»',
  'identity.visit.exitSource.shift_closed': 'закрытие смены',
  'identity.visit.vehicle': 'Автомобиль',
  'identity.visit.driver': 'За рулём',
  'identity.visit.role.owner': 'владелец',
  'identity.visit.role.driver': 'водитель',
  'identity.visit.role.fleet': 'парк',
  'identity.visit.operator': 'Оператор',
  'identity.visit.orders': 'Заказы',
  'identity.visit.noOrders': 'Заказов нет',
  'identity.visit.photos': 'Снимки',
  'identity.visit.noPhotos': 'Снимков нет: камера въезда не прислала кадр, фото до и после мойки не сделаны',
  'identity.visit.stage.entry': 'Въезд (камера)',
  'identity.visit.stage.before': 'До мойки',
  'identity.visit.stage.after': 'После мойки',
  'identity.visit.frames': 'Кадры камер',
  'identity.visit.notStarted': 'не начата',
  'identity.visit.onSite': 'на объекте',
  'identity.st.active': 'Активный',
  'identity.st.dormant': 'Спящий',
  'identity.st.blocked': 'Заблокирован',
  'identity.st.merged': 'Склеен',
  'identity.st.forgotten': 'Забыт по требованию',
  'identity.role.owner': 'Владелец',
  'identity.role.driver': 'Водитель',
  'identity.role.company': 'Автомобиль компании',
  'identity.ord.draft': 'Черновик',
  'identity.ord.confirmed': 'Ждёт оплаты',
  'identity.ord.in_progress': 'В работе',
  'identity.ord.completed': 'Оплачен',
  'identity.ord.cancelled': 'Отменён',
  'identity.ch.qr': 'QR-код',
  'identity.ch.app': 'Приложение',
  'identity.ch.phone': 'Телефон',
  'identity.ch.whatsapp': 'WhatsApp',
  'identity.ch.import': 'Импорт',
  'identity.fb.new': 'Новое',
  'identity.fb.in_progress': 'В работе',
  'identity.fb.answered': 'Отвечено',
  'identity.fb.closed': 'Закрыто',
  'identity.fb.escalated': 'Эскалировано',
  'identity.card.noVisits': 'Визитов пока нет',

  'identity.card.orders': 'Покупки',
  'identity.card.orderNo': 'Номер',
  'identity.card.total': 'Сумма',
  'identity.card.orderStatus': 'Состояние',
  'identity.card.noOrders': 'Покупок нет',

  'identity.card.payments': 'Платежи',
  'identity.card.provider': 'Провайдер',
  'identity.card.kind': 'Вид',
  'identity.card.noPayments': 'Платежей нет',

  'identity.card.feedback': 'Обращения',
  'identity.card.channel': 'Канал',
  'identity.card.score': 'Оценка',
  'identity.card.text': 'Текст',
  'identity.card.due': 'Срок',
  'identity.card.overdue': 'просрочено',
  'identity.card.noFeedback': 'Обращений не было',

  'identity.card.consents': 'Согласия',
  'identity.card.consentData': 'На обработку данных',
  'identity.card.consentMarketing': 'На маркетинг',
  'identity.card.granted': 'дано',
  'identity.card.revoked': 'нет',
  'identity.body.minibus': 'Микроавтобус',
  'identity.tab.retention': 'Сроки хранения ПДн',
  'identity.retention.what': 'Данные',
  'identity.retention.owner': 'Модуль',
  'identity.retention.days': 'Хранить, дней',
  'identity.retention.lastRun': 'Последняя очистка',
  'identity.retention.affected': 'записей: {n}',
  'identity.retention.never': 'ещё не запускалась',
  'identity.retention.saved': 'Срок хранения изменён',
  'identity.retention.hint': 'После срока данные стираются задачами модулей: кадры и номера распознавания, тексты сообщений, контакты закрытых обращений, коды подтверждения. Статистика и история визитов остаются.',
  'identity.tab.companies': 'Юрлица и автопарк',
  'identity.company.list': 'Юрлица',
  'identity.company.search': 'Название или БИН',
  'identity.company.name': 'Название',
  'identity.company.fleet': 'Машин в парке',
  'identity.company.open': 'Открыть',
  'identity.company.none': 'Юрлиц не найдено',
  'identity.company.create': 'Завести юрлицо',
  'identity.company.binHint': '12 цифр',
  'identity.company.created': 'Юрлицо заведено',
  'identity.company.pick': 'Юрлицо не выбрано',
  'identity.company.pickReason': 'Выберите юрлицо в списке или заведите новое.',
  'identity.company.visits': 'визитов: {total}, за 30 дней: {recent}',
  'identity.company.noFleet': 'В автопарке пока нет машин',
  'identity.company.addVehicle': 'Номер автомобиля',
  'identity.company.add': 'Добавить',
  'identity.company.remove': 'Убрать',
  'identity.company.vehicleAdded': 'Машина добавлена в парк',
  'identity.company.vehicleRemoved': 'Машина выведена из парка',
  'identity.company.drivers': 'Водители',
  'identity.company.noDrivers': 'Водители не привязаны',
  'identity.company.driverAdded': 'Водитель привязан',
  'identity.company.driverRemoved': 'Водитель снят с юрлица',
  'identity.company.managers': 'Кабинет компании: представители',
  'identity.company.managersHint': 'Представитель входит в кабинет компании по коду на свой телефон: автопарк, визиты, счета и отчёты.',
  'identity.company.noManagers': 'Доступ в кабинет компании никому не открыт',
  'identity.company.grant': 'Открыть доступ',
  'identity.company.revoke': 'Закрыть доступ',
  'identity.company.granted': 'Доступ открыт',
  'identity.company.revoked': 'Доступ закрыт',
  'identity.card.saved': 'Сохранено',
  'identity.card.save': 'Сохранить',
  'identity.card.cancel': 'Отмена',
  'identity.card.edit': 'Изменить',
  'identity.card.editProfile': 'Профиль клиента',
  'identity.card.editVehicle': 'Автомобиль {plate}',
  'identity.card.name': 'Имя',
  'identity.card.email': 'E-mail',
  'identity.card.emailHint': 'Для чеков и уведомлений. Пусто — убрать адрес.',
  'identity.card.make': 'Марка',
  'identity.card.model': 'Модель',
  'identity.card.bodyType': 'Тип кузова',
  'identity.card.sizeClass': 'Габарит',
  'identity.card.coating': 'Особенности покрытия',
  'identity.card.coatingHint': 'Керамика, плёнка, матовая краска — что учесть мойщику.',
  'identity.card.sendCode': 'Подтвердить кодом',
  'identity.card.code': 'Код из SMS',
  'identity.card.checkCode': 'Проверить',
  'identity.card.codeSent': 'Код отправлен клиенту',
  'identity.card.phoneVerifiedNow': 'Телефон подтверждён',
  'identity.card.phoneVerified': 'Телефон подтверждён',
  'identity.card.phoneNotVerified': 'не подтверждён',
  'identity.card.email.none': 'не указан',
  'identity.card.type': 'Тип',
  'identity.card.company': 'Юрлицо',
  'identity.card.bin': 'БИН',
  'identity.card.firstVisit': 'Первый визит',
  'identity.card.lastVisit': 'Последний визит',
  'identity.card.churn': 'Риск оттока',
  'identity.card.churnNone': 'модель ещё не оценила',
  'identity.card.churnHint': 'Оценка модели на истории визитов сети, обновляется ежедневно',
  'identity.card.moreVisits': 'Показать ещё',
  'identity.card.allVisits': 'Показаны все визиты',
  'identity.body.sedan': 'Седан',
  'identity.body.hatchback': 'Хэтчбек',
  'identity.body.wagon': 'Универсал',
  'identity.body.coupe': 'Купе',
  'identity.body.suv': 'Внедорожник',
  'identity.body.pickup': 'Пикап',
  'identity.body.van': 'Фургон',
  'identity.body.truck': 'Грузовой',
  'identity.body.bus': 'Автобус',
  'identity.body.motorcycle': 'Мотоцикл',
  'identity.type.individual': 'Частное лицо',
  'identity.type.company': 'Юрлицо',

  'identity.tab.duplicates': 'Дубли',
  'identity.tab.similar': 'Похожие номера',
  'identity.tab.merge': 'Слияние и разделение',
  'identity.tab.conflict': 'Конфликт идентификации',
  'identity.tab.consents': 'Согласия',
  'identity.tab.segments': 'Сегменты',

  'identity.duplicates.scan': 'Пересканировать',
  'identity.duplicates.scanning': 'Сканируем…',
  'identity.duplicates.empty': 'Кандидатов нет',
  'identity.duplicates.scanned': 'Найдено новых пар: {proposed}',
  'identity.duplicates.selected': 'Выбрано: {n}',
  'identity.duplicates.confirm': 'Подтвердить слияние',
  'identity.duplicates.reject': 'Отклонить',
  'identity.duplicates.reason': 'Основание',
  'identity.duplicates.reasonHint': 'Обязательно: почему пара сливается или отклоняется',
  'identity.duplicates.score': 'Уверенность',
  'identity.duplicates.kind': 'Признак',
  'identity.duplicates.evidence': 'Совпало',
  'identity.duplicates.pair': 'Пара',
  'identity.duplicates.compare': 'Сравнить',
  'identity.duplicates.humanOnly':
    'Похожие номера никогда не сливаются автоматически и не подтверждаются пачкой — только вручную, после сравнения.',
  'identity.duplicates.rejectedOnce': 'Отклонённая пара больше не предлагается.',
  'identity.duplicates.needSelection': 'Отметьте хотя бы одну пару',
  'identity.duplicates.needReason': 'Укажите основание — оно попадёт в журнал действий',
  'identity.duplicates.mergedOk': 'Слито пар: {n}',
  'identity.duplicates.rejectedOk': 'Отклонено пар: {n}',
  'identity.duplicates.noName': 'Без имени',
  'identity.duplicates.noPhone': 'Телефон не указан',
  'identity.duplicates.visits': 'визитов: {n}',

  'identity.kind.same_phone': 'Совпадение телефона',
  'identity.kind.same_vehicle': 'Общий автомобиль',
  'identity.kind.similar_plate': 'Похожий номер',
  'identity.kind.same_name_vehicle': 'Имя и автомобиль',

  'identity.compare.title': 'Сравнение записей',
  'identity.compare.left': 'Запись A',
  'identity.compare.right': 'Запись B',
  'identity.compare.keepLeft': 'Оставить A как основную',
  'identity.compare.keepRight': 'Оставить B как основную',
  'identity.compare.phone': 'Телефон',
  'identity.compare.phones': 'Все телефоны',
  'identity.compare.vehicles': 'Автомобили',
  'identity.compare.visits': 'Визитов',
  'identity.compare.lastVisit': 'Последний визит',
  'identity.compare.paid': 'Оплачено',
  'identity.compare.balance': 'Баланс бонусов',
  'identity.compare.feedback': 'Обращений',
  'identity.compare.consents': 'Согласия',
  'identity.compare.merges': 'История склеек',
  'identity.compare.created': 'Заведён',
  'identity.compare.status': 'Статус',

  'identity.merge.title': 'Слияние записей',
  'identity.merge.primary': 'Основная запись',
  'identity.merge.source': 'Присоединяемая запись',
  'identity.merge.submit': 'Слить',
  'identity.merge.done': 'Слито, склейка {mergeId}',
  'identity.merge.onlyAdmin': 'Операция доступна только администратору сети.',
  'identity.merge.primaryHint': 'Запись, которая останется после слияния',
  'identity.merge.sourceHint': 'Запись, которая будет присоединена и закроется',
  'identity.merges.title': 'Журнал склеек',
  'identity.merges.empty': 'Склеек ещё не было',
  'identity.merges.emptyReason':
    'Здесь появятся все слияния — с идентификатором, основанием и кнопкой разделения.',
  'identity.merges.when': 'Когда',
  'identity.merges.pair': 'Основная ← присоединённая',
  'identity.merges.moved': 'Что перенесено',
  'identity.merges.state': 'Состояние',
  'identity.merges.active': 'действует',
  'identity.merges.reverted': 'разделено {at}',
  'identity.split.confirmTitle': 'Разделить склеенные записи?',
  'identity.split.confirmBody': 'Запись «{merged}» будет отсоединена от «{primary}».',
  'identity.split.consequence': 'Обратно вернётся перенесённое: {moved}',
  'identity.split.reasonPrompt': 'Основание разделения (попадёт в журнал действий)',
  'identity.split.title': 'Разделение записей',
  'identity.split.mergeId': 'Идентификатор склейки',
  'identity.split.submit': 'Разделить',
  'identity.split.done': 'Разделено, запись восстановлена',
  'identity.split.hint':
    'Состав склейки сохраняется в момент операции, поэтому разделение работает и спустя месяцы.',

  'identity.conflict.title': 'Разрешение конфликта идентификации',
  'identity.conflict.vehicle': 'Автомобиль',
  'identity.conflict.vehicleHint': 'Машина, из-за которой спор. Ищем по номеру.',
  'identity.conflict.challenger': 'Второй клиент',
  'identity.conflict.challengerHint':
    'Тот, кто претендует на машину. Ищем по телефону или номеру автомобиля.',
  'identity.conflict.plate': 'Номер',
  'identity.conflict.noName': 'Без имени',
  'identity.conflict.load': 'Показать',
  'identity.conflict.current': 'Текущая связь',
  'identity.conflict.since': 'Действует с',
  'identity.conflict.none': 'Активной связи нет',
  'identity.conflict.keep': 'Оставить за этим клиентом',
  'identity.conflict.done': 'Связь переоформлена',
  'identity.conflict.hint':
    'Прежняя связь закрывается датой, новая открывается. Автоматическая склейка не выполняется.',

  'identity.consents.title': 'Согласия клиента',
  'identity.consents.customer': 'Клиент',
  'identity.consents.load': 'Показать',
  'identity.consents.dataProcessing': 'Обработка данных',
  'identity.consents.marketing': 'Маркетинг',
  'identity.consents.active': 'Действует',
  'identity.consents.inactive': 'Не действует',
  'identity.consents.grant': 'Выдать',
  'identity.consents.withdrawOne': 'Отозвать',
  'identity.consents.customerHint': 'Найдите по телефону или номеру автомобиля',
  'identity.consents.event': 'Событие',
  'identity.consents.eventGranted': 'согласие выдано',
  'identity.consents.eventExpired': 'согласие больше не действует',
  'identity.consents.eventWithdrawn': 'согласие отозвано',
  'identity.consents.granted': 'Согласие зафиксировано',
  'identity.consents.withdrawn': 'Согласие отозвано',
  'identity.consents.anonymizeConfirm': 'Обезличить персональные данные клиента?',
  'identity.consents.anonymizeWord': 'ОБЕЗЛИЧИТЬ',
  'identity.consents.anonymizeIrreversible':
    'Действие необратимо: восстановить имя и телефон будет нечем.',
  'identity.consents.effectPii': 'Имя, телефон и контакты будут удалены безвозвратно',
  'identity.consents.effectLinks': 'Связи с автомобилями закроются, клиент выпадет из сегментов',
  'identity.consents.effectAudit': 'В журнале действий останется запись с вашим основанием',
  'identity.consents.history': 'История',
  'identity.consents.version': 'Версия текста',
  'identity.consents.channel': 'Канал',
  'identity.consents.grantedAt': 'Выдано',
  'identity.consents.withdrawnAt': 'Отозвано',
  'identity.consents.marketingGate':
    'Без действующего маркетингового согласия клиент не попадает ни в один сегмент и ни в одну рассылку.',
  'identity.consents.anonymize': 'Отозвать согласие и обезличить',
  'identity.consents.anonymizeWarn':
    'Операция необратима. Персональные данные удаляются, финансовая история сохраняется.',
  'identity.consents.anonymized': 'Клиент обезличен',

  'identity.segments.title': 'Конструктор сегментов',
  'identity.segments.name': 'Название',
  'identity.segments.code': 'Код',
  'identity.segments.mode': 'Обновление',
  'identity.segments.modeLive': 'Живое',
  'identity.segments.modeScheduled': 'По расписанию',
  'identity.segments.interval': 'Интервал, минут',
  'identity.segments.addRule': 'Добавить условие',
  'identity.segments.addGroup': 'Добавить группу',
  'identity.segments.remove': 'Убрать',
  'identity.segments.match': 'Совпадение',
  'identity.segments.all': 'Все условия',
  'identity.segments.any': 'Любое условие',
  'identity.segments.preview': 'Показать размер',
  'identity.segments.size': 'Размер сегмента: {n}',
  'identity.segments.save': 'Сохранить сегмент',
  'identity.segments.saved': 'Сегмент сохранён',
  'identity.segments.existing': 'Сохранённые сегменты',
  'identity.segments.refresh': 'Пересобрать',
  'identity.segments.members': 'Состав',
  'identity.segments.asOf': 'Актуально на',
  'identity.segments.lastSize': 'Размер',
  'identity.segments.edit': 'Изменить',
  'identity.segments.delete': 'Удалить',
  'identity.segments.deleteTitle': 'Удалить сегмент «{name}»?',
  'identity.segments.deleteBody': 'Сегмент уйдёт в архив: пересобираться и участвовать в новых рассылках он перестанет, история рассылок по нему сохранится.',
  'identity.segments.archived': 'в архиве',
  'identity.segments.editing': 'Правка сегмента «{name}»',
  'identity.segments.cancelEdit': 'Отменить правку',
  'identity.segments.field': 'Поле',
  'identity.segments.operator': 'Оператор',
  'identity.segments.value': 'Значение',
  'identity.segments.window': 'Окно, дней',
  'identity.segments.noCode':
    'Определение сегмента — данные, а не код: правка не требует участия разработчика и выкладки.',

  'identity.segments.liveNoRefresh': 'считается при каждом обращении',
  'identity.segments.memberName': 'Клиент',
  'identity.segments.memberPhone': 'Телефон',
  'identity.segments.memberVisits': 'Визитов',
  'identity.segments.memberLastVisit': 'Последний визит',
  'identity.segments.memberTier': 'Уровень',
  'identity.segments.memberNoName': 'Без имени',
  'identity.field.recency_days': 'Дней с последнего визита',
  'identity.field.visit_count': 'Число визитов',
  'identity.field.paid_order_count': 'Число оплаченных заказов',
  'identity.field.monetary_minor': 'Сумма покупок, ₸',
  'identity.field.avg_check_minor': 'Средний чек, ₸',
  'identity.field.loyalty_balance_minor': 'Баланс бонусов, ₸',
  'identity.field.lifetime_days': 'Дней с регистрации',
  'identity.field.churn_risk_pct': 'Риск оттока, %',
  'identity.field.customer_type': 'Тип клиента',
  'identity.field.customer_source': 'Источник',
  'identity.field.customer_status': 'Статус',
  'identity.field.loyalty_tier_code': 'Уровень лояльности',
  'identity.field.vehicle_size_class': 'Класс автомобиля',
  'identity.field.vehicle_make': 'Марка автомобиля',
  'identity.field.visited_site_id': 'Посещал объект',
  'identity.field.phone_verified': 'Телефон подтверждён',
  'identity.field.has_email': 'Есть почта',
  'identity.field.has_vehicle': 'Есть автомобиль',
  'identity.field.has_visits': 'Есть визиты',
  'identity.field.display_name': 'Имя',

  'identity.op.eq': 'равно',
  'identity.op.ne': 'не равно',
  'identity.op.lt': 'меньше',
  'identity.op.lte': 'меньше или равно',
  'identity.op.gt': 'больше',
  'identity.op.gte': 'больше или равно',
  'identity.op.in': 'входит в',
  'identity.op.not_in': 'не входит в',
  'identity.op.contains': 'содержит',
  'identity.op.starts_with': 'начинается с',
  'identity.op.yes': 'да',
  'identity.op.no': 'нет',

  'identity.common.cancel': 'Отмена',
  'identity.common.close': 'Закрыть',
  'identity.common.loading': 'Загрузка…',
  'identity.common.nothing': 'Ничего не найдено',
  'identity.common.required': 'Заполните обязательные поля',
  'identity.common.forbidden': 'Недостаточно прав для этого раздела',

} as const;

const KK: Record<keyof typeof RU, string> = {
  'identity.tab.card': 'Клиент картасы',

  'identity.card.pick': 'Клиент',
  'identity.card.pickHint': 'Телефон немесе көлік нөмірі бойынша табыңыз',
  'identity.card.none': 'Клиент таңдалмаған',
  'identity.card.noneReason':
    'Карта клиенттің желі бойынша тарихын жинайды: байланыстар, көліктер, барулар, сатып алулар, жазылым, бонустар, өтініштер және келісімдер. Іздеуден бастаңыз.',
  'identity.card.profile': 'Профиль',
  'identity.card.history': 'Өзгерістер тарихы',
  'identity.card.noName': 'Атауы жоқ',
  'identity.card.phone': 'Телефон',
  'identity.card.status': 'Мәртебе',
  'identity.card.copyLink': 'Сілтемені көшіру',
  'identity.card.another': 'Басқа клиент',
  'identity.card.linkCopied': 'Картаға сілтеме көшірілді',

  'identity.card.loyalty': 'Адалдық',
  'identity.card.tier': 'Деңгей',
  'identity.card.noTier': 'Деңгей берілмеген',
  'identity.card.nextTier': '«{name}» деңгейіне дейін',
  'identity.card.needVisits': 'бару: {n}',
  'identity.card.needSpend': 'шығын: {sum}',
  'identity.card.needAccrued': 'есептеу: {sum}',
  'identity.card.balance': 'Баланс',
  'identity.card.materialized': 'Материалданған',
  'identity.card.drift': 'Алшақтық',
  'identity.card.noAccount': 'Бонустық шот әлі ашылмаған — есептеу болмаған',
  'identity.card.offers': 'Не ұсынуға болады',
  'identity.card.noOffers': 'Қазір қолайлы ереже жоқ',

  'identity.card.subscriptions': 'Жазылым',
  'identity.card.plan': 'Жоспар',
  'identity.card.period': 'Кезең',
  'identity.card.until': 'Дейін төленген',
  'identity.card.autorenew': 'Автожаңарту',
  'identity.card.autorenewOn': 'қосулы',
  'identity.card.autorenewOff': 'өшірулі',
  'identity.card.noSubscriptions': 'Жазылым жоқ',
  'identity.card.noSubscriptionsReason': 'Клиент әр жуу үшін бөлек төлейді.',

  'identity.card.vehicles': 'Көліктер',
  'identity.card.plate': 'Нөмір',
  'identity.card.role': 'Рөл',
  'identity.card.since': 'Бастап',
  'identity.card.till': 'Дейін',
  'identity.card.noVehicles': 'Көлік байланыстырылмаған',
  'identity.card.noVehiclesReason':
    'Көлікке байланыссыз клиент кіреберісте танылмайды — бұл сәйкестендірудің негізгі кілті.',

  'identity.card.visits': 'Барулар',
  'identity.card.visitAt': 'Қашан',
  'identity.card.site': 'Нысан',
  'identity.card.method': 'Қалай танылды',
  'identity.method.lpr': 'Нөмірі бойынша',
  'identity.method.manual': 'Оператор енгізген',
  'identity.method.phone': 'Телефоны бойынша',
  'identity.method.declined': 'Клиент бас тартты',
  'identity.method.pending': 'Танылмаған',
  'identity.card.siteUnknown': 'Нысан табылмады',

  'identity.visit.title': 'Бару',
  'identity.visit.hint': 'Карточканы ашу үшін тізімдегі баруды басыңыз',
  'identity.visit.close': 'Жабу',
  'identity.visit.entered': 'Кіру',
  'identity.visit.started': 'Жуудың басталуы',
  'identity.visit.exited': 'Шығу',
  'identity.visit.entrySpeed': 'Кіруден басталуға дейін',
  'identity.visit.cycle': 'Цикл уақыты',
  'identity.visit.exitSource.lpr': 'шығу камерасы',
  'identity.visit.exitSource.operator': '«Дайын» түймесі',
  'identity.visit.exitSource.shift_closed': 'ауысымның жабылуы',
  'identity.visit.vehicle': 'Көлік',
  'identity.visit.driver': 'Рульде',
  'identity.visit.role.owner': 'иесі',
  'identity.visit.role.driver': 'жүргізуші',
  'identity.visit.role.fleet': 'парк',
  'identity.visit.operator': 'Оператор',
  'identity.visit.orders': 'Тапсырыстар',
  'identity.visit.noOrders': 'Тапсырыс жоқ',
  'identity.visit.photos': 'Суреттер',
  'identity.visit.noPhotos': 'Сурет жоқ: кіру камерасы кадр жібермеді, жууға дейін және кейін суретке түсірілмеді',
  'identity.visit.stage.entry': 'Кіру (камера)',
  'identity.visit.stage.before': 'Жууға дейін',
  'identity.visit.stage.after': 'Жуудан кейін',
  'identity.visit.frames': 'Камера кадрлары',
  'identity.visit.notStarted': 'басталмады',
  'identity.visit.onSite': 'нысанда',
  'identity.st.active': 'Белсенді',
  'identity.st.dormant': 'Ұйықтаған',
  'identity.st.blocked': 'Бұғатталған',
  'identity.st.merged': 'Біріктірілген',
  'identity.st.forgotten': 'Талап бойынша ұмытылған',
  'identity.role.owner': 'Иесі',
  'identity.role.driver': 'Жүргізуші',
  'identity.role.company': 'Компания көлігі',
  'identity.ord.draft': 'Жоба',
  'identity.ord.confirmed': 'Төлемді күтуде',
  'identity.ord.in_progress': 'Жұмыста',
  'identity.ord.completed': 'Төленген',
  'identity.ord.cancelled': 'Болдырылған',
  'identity.ch.qr': 'QR-код',
  'identity.ch.app': 'Қосымша',
  'identity.ch.phone': 'Телефон',
  'identity.ch.whatsapp': 'WhatsApp',
  'identity.ch.import': 'Импорт',
  'identity.fb.new': 'Жаңа',
  'identity.fb.in_progress': 'Жұмыста',
  'identity.fb.answered': 'Жауап берілді',
  'identity.fb.closed': 'Жабылды',
  'identity.fb.escalated': 'Эскалацияланды',
  'identity.card.noVisits': 'Бару әлі жоқ',

  'identity.card.orders': 'Сатып алулар',
  'identity.card.orderNo': 'Нөмір',
  'identity.card.total': 'Сома',
  'identity.card.orderStatus': 'Күйі',
  'identity.card.noOrders': 'Сатып алу жоқ',

  'identity.card.payments': 'Төлемдер',
  'identity.card.provider': 'Провайдер',
  'identity.card.kind': 'Түрі',
  'identity.card.noPayments': 'Төлем жоқ',

  'identity.card.feedback': 'Өтініштер',
  'identity.card.channel': 'Арна',
  'identity.card.score': 'Баға',
  'identity.card.text': 'Мәтін',
  'identity.card.due': 'Мерзім',
  'identity.card.overdue': 'мерзімі өтті',
  'identity.card.noFeedback': 'Өтініш болмаған',

  'identity.card.consents': 'Келісімдер',
  'identity.card.consentData': 'Деректерді өңдеуге',
  'identity.card.consentMarketing': 'Маркетингке',
  'identity.card.granted': 'берілген',
  'identity.card.revoked': 'жоқ',
  'identity.body.minibus': 'Шағын автобус',
  'identity.tab.retention': 'ДЖ сақтау мерзімдері',
  'identity.retention.what': 'Деректер',
  'identity.retention.owner': 'Модуль',
  'identity.retention.days': 'Сақтау, күн',
  'identity.retention.lastRun': 'Соңғы тазалау',
  'identity.retention.affected': 'жазбалар: {n}',
  'identity.retention.never': 'әлі іске қосылмаған',
  'identity.retention.saved': 'Сақтау мерзімі өзгертілді',
  'identity.retention.hint': 'Мерзім өткен соң деректерді модуль тапсырмалары өшіреді: тану кадрлары мен нөмірлері, хабарлама мәтіндері, жабық өтініш байланыстары, растау кодтары. Статистика мен келулер тарихы қалады.',
  'identity.tab.companies': 'Заңды тұлғалар мен автопарк',
  'identity.company.list': 'Заңды тұлғалар',
  'identity.company.search': 'Атауы немесе БСН',
  'identity.company.name': 'Атауы',
  'identity.company.fleet': 'Парктегі көліктер',
  'identity.company.open': 'Ашу',
  'identity.company.none': 'Заңды тұлғалар табылмады',
  'identity.company.create': 'Заңды тұлға енгізу',
  'identity.company.binHint': '12 цифр',
  'identity.company.created': 'Заңды тұлға енгізілді',
  'identity.company.pick': 'Заңды тұлға таңдалмаған',
  'identity.company.pickReason': 'Тізімнен таңдаңыз немесе жаңасын енгізіңіз.',
  'identity.company.visits': 'келулер: {total}, 30 күнде: {recent}',
  'identity.company.noFleet': 'Автопаркте әзірге көлік жоқ',
  'identity.company.addVehicle': 'Көлік нөмірі',
  'identity.company.add': 'Қосу',
  'identity.company.remove': 'Алып тастау',
  'identity.company.vehicleAdded': 'Көлік паркке қосылды',
  'identity.company.vehicleRemoved': 'Көлік парктен шығарылды',
  'identity.company.drivers': 'Жүргізушілер',
  'identity.company.noDrivers': 'Жүргізушілер байланыстырылмаған',
  'identity.company.driverAdded': 'Жүргізуші байланыстырылды',
  'identity.company.driverRemoved': 'Жүргізуші алып тасталды',
  'identity.company.managers': 'Компания кабинеті: өкілдер',
  'identity.company.managersHint': 'Өкіл компания кабинетіне өз телефонына келген код арқылы кіреді: автопарк, келулер, шоттар және есептер.',
  'identity.company.noManagers': 'Компания кабинетіне ешкімге рұқсат ашылмаған',
  'identity.company.grant': 'Рұқсат ашу',
  'identity.company.revoke': 'Рұқсатты жабу',
  'identity.company.granted': 'Рұқсат ашылды',
  'identity.company.revoked': 'Рұқсат жабылды',
  'identity.card.saved': 'Сақталды',
  'identity.card.save': 'Сақтау',
  'identity.card.cancel': 'Болдырмау',
  'identity.card.edit': 'Өзгерту',
  'identity.card.editProfile': 'Клиент профилі',
  'identity.card.editVehicle': 'Автокөлік {plate}',
  'identity.card.name': 'Аты',
  'identity.card.email': 'E-mail',
  'identity.card.emailHint': 'Чектер мен хабарламалар үшін. Бос — мекенжайды алып тастау.',
  'identity.card.make': 'Маркасы',
  'identity.card.model': 'Моделі',
  'identity.card.bodyType': 'Шанақ түрі',
  'identity.card.sizeClass': 'Габарит',
  'identity.card.coating': 'Жабын ерекшеліктері',
  'identity.card.coatingHint': 'Керамика, үлдір, күңгірт бояу — жуушы ескеретін нәрсе.',
  'identity.card.sendCode': 'Кодпен растау',
  'identity.card.code': 'SMS коды',
  'identity.card.checkCode': 'Тексеру',
  'identity.card.codeSent': 'Код клиентке жіберілді',
  'identity.card.phoneVerifiedNow': 'Телефон расталды',
  'identity.card.phoneVerified': 'Телефон расталған',
  'identity.card.phoneNotVerified': 'расталмаған',
  'identity.card.email.none': 'көрсетілмеген',
  'identity.card.type': 'Түрі',
  'identity.card.company': 'Заңды тұлға',
  'identity.card.bin': 'БСН',
  'identity.card.firstVisit': 'Алғашқы келу',
  'identity.card.lastVisit': 'Соңғы келу',
  'identity.card.churn': 'Кету қаупі',
  'identity.card.churnNone': 'модель әлі бағаламады',
  'identity.card.churnHint': 'Желі келу тарихы бойынша модель бағасы, күн сайын жаңарады',
  'identity.card.moreVisits': 'Тағы көрсету',
  'identity.card.allVisits': 'Барлық келулер көрсетілді',
  'identity.body.sedan': 'Седан',
  'identity.body.hatchback': 'Хэтчбек',
  'identity.body.wagon': 'Универсал',
  'identity.body.coupe': 'Купе',
  'identity.body.suv': 'Жол талғамайтын',
  'identity.body.pickup': 'Пикап',
  'identity.body.van': 'Фургон',
  'identity.body.truck': 'Жүк көлігі',
  'identity.body.bus': 'Автобус',
  'identity.body.motorcycle': 'Мотоцикл',
  'identity.type.individual': 'Жеке тұлға',
  'identity.type.company': 'Заңды тұлға',

  'identity.tab.duplicates': 'Телнұсқалар',
  'identity.tab.similar': 'Ұқсас нөмірлер',
  'identity.tab.merge': 'Біріктіру және бөлу',
  'identity.tab.conflict': 'Сәйкестендіру қақтығысы',
  'identity.tab.consents': 'Келісімдер',
  'identity.tab.segments': 'Сегменттер',

  'identity.duplicates.scan': 'Қайта сканерлеу',
  'identity.duplicates.scanning': 'Сканерленуде…',
  'identity.duplicates.empty': 'Үміткерлер жоқ',
  'identity.duplicates.scanned': 'Жаңа жұптар табылды: {proposed}',
  'identity.duplicates.selected': 'Таңдалды: {n}',
  'identity.duplicates.confirm': 'Біріктіруді растау',
  'identity.duplicates.reject': 'Қабылдамау',
  'identity.duplicates.reason': 'Негіздеме',
  'identity.duplicates.reasonHint': 'Міндетті: жұп неге біріктіріледі немесе қабылданбайды',
  'identity.duplicates.score': 'Сенімділік',
  'identity.duplicates.kind': 'Белгі',
  'identity.duplicates.evidence': 'Сәйкес келді',
  'identity.duplicates.pair': 'Жұп',
  'identity.duplicates.compare': 'Салыстыру',
  'identity.duplicates.humanOnly':
    'Ұқсас нөмірлер ешқашан автоматты біріктірілмейді және топтап расталмайды — тек қолмен, салыстырудан кейін.',
  'identity.duplicates.rejectedOnce': 'Қабылданбаған жұп қайта ұсынылмайды.',
  'identity.duplicates.needSelection': 'Кемінде бір жұпты белгілеңіз',
  'identity.duplicates.needReason': 'Негіздемені көрсетіңіз — ол әрекеттер журналына түседі',
  'identity.duplicates.mergedOk': 'Біріктірілген жұп: {n}',
  'identity.duplicates.rejectedOk': 'Қабылданбаған жұп: {n}',
  'identity.duplicates.noName': 'Атауы жоқ',
  'identity.duplicates.noPhone': 'Телефон көрсетілмеген',
  'identity.duplicates.visits': 'келу саны: {n}',

  'identity.kind.same_phone': 'Телефон сәйкестігі',
  'identity.kind.same_vehicle': 'Ортақ көлік',
  'identity.kind.similar_plate': 'Ұқсас нөмір',
  'identity.kind.same_name_vehicle': 'Аты және көлігі',

  'identity.compare.title': 'Жазбаларды салыстыру',
  'identity.compare.left': 'Жазба A',
  'identity.compare.right': 'Жазба B',
  'identity.compare.keepLeft': 'A негізгі болып қалсын',
  'identity.compare.keepRight': 'B негізгі болып қалсын',
  'identity.compare.phone': 'Телефон',
  'identity.compare.phones': 'Барлық телефондар',
  'identity.compare.vehicles': 'Көліктер',
  'identity.compare.visits': 'Келулер',
  'identity.compare.lastVisit': 'Соңғы келу',
  'identity.compare.paid': 'Төленген',
  'identity.compare.balance': 'Бонус балансы',
  'identity.compare.feedback': 'Өтініштер',
  'identity.compare.consents': 'Келісімдер',
  'identity.compare.merges': 'Біріктіру тарихы',
  'identity.compare.created': 'Тіркелген',
  'identity.compare.status': 'Күйі',

  'identity.merge.title': 'Жазбаларды біріктіру',
  'identity.merge.primary': 'Негізгі жазба',
  'identity.merge.source': 'Қосылатын жазба',
  'identity.merge.submit': 'Біріктіру',
  'identity.merge.done': 'Біріктірілді, {mergeId}',
  'identity.merge.onlyAdmin': 'Операция тек желі әкімшісіне қолжетімді.',
  'identity.merge.primaryHint': 'Біріктіруден кейін қалатын жазба',
  'identity.merge.sourceHint': 'Қосылатын және жабылатын жазба',
  'identity.merges.title': 'Біріктіру журналы',
  'identity.merges.empty': 'Біріктіру әлі болған жоқ',
  'identity.merges.emptyReason':
    'Мұнда барлық біріктірулер шығады — идентификаторымен, негіздемесімен және бөлу түймесімен.',
  'identity.merges.when': 'Қашан',
  'identity.merges.pair': 'Негізгі ← қосылған',
  'identity.merges.moved': 'Не көшірілді',
  'identity.merges.state': 'Күйі',
  'identity.merges.active': 'қолданыста',
  'identity.merges.reverted': '{at} бөлінген',
  'identity.split.confirmTitle': 'Біріктірілген жазбаларды бөлу керек пе?',
  'identity.split.confirmBody': '«{merged}» жазбасы «{primary}» жазбасынан ажыратылады.',
  'identity.split.consequence': 'Көшірілгені қайтарылады: {moved}',
  'identity.split.reasonPrompt': 'Бөлу негіздемесі (әрекеттер журналына түседі)',
  'identity.split.title': 'Жазбаларды бөлу',
  'identity.split.mergeId': 'Біріктіру идентификаторы',
  'identity.split.submit': 'Бөлу',
  'identity.split.done': 'Бөлінді, жазба қалпына келтірілді',
  'identity.split.hint':
    'Біріктіру құрамы операция сәтінде сақталады, сондықтан бөлу айлар өткен соң да жұмыс істейді.',

  'identity.conflict.title': 'Сәйкестендіру қақтығысын шешу',
  'identity.conflict.vehicle': 'Автокөлік',
  'identity.conflict.vehicleHint': 'Дау туындаған көлік. Нөмірі бойынша іздейміз.',
  'identity.conflict.challenger': 'Екінші клиент',
  'identity.conflict.challengerHint':
    'Көлікке үміткер. Телефоны немесе көлік нөмірі бойынша іздейміз.',
  'identity.conflict.plate': 'Нөмірі',
  'identity.conflict.noName': 'Атауы жоқ',
  'identity.conflict.load': 'Көрсету',
  'identity.conflict.current': 'Ағымдағы байланыс',
  'identity.conflict.since': 'Күшінде',
  'identity.conflict.none': 'Белсенді байланыс жоқ',
  'identity.conflict.keep': 'Осы клиентте қалдыру',
  'identity.conflict.done': 'Байланыс қайта ресімделді',
  'identity.conflict.hint':
    'Бұрынғы байланыс күнмен жабылады, жаңасы ашылады. Автоматты біріктіру орындалмайды.',

  'identity.consents.title': 'Клиент келісімдері',
  'identity.consents.customer': 'Клиент',
  'identity.consents.load': 'Көрсету',
  'identity.consents.dataProcessing': 'Деректерді өңдеу',
  'identity.consents.marketing': 'Маркетинг',
  'identity.consents.active': 'Күшінде',
  'identity.consents.inactive': 'Күшінде емес',
  'identity.consents.grant': 'Беру',
  'identity.consents.withdrawOne': 'Кері қайтару',
  'identity.consents.customerHint': 'Телефон немесе көлік нөмірі бойынша табыңыз',
  'identity.consents.event': 'Оқиға',
  'identity.consents.eventGranted': 'келісім берілді',
  'identity.consents.eventExpired': 'келісім енді жарамсыз',
  'identity.consents.eventWithdrawn': 'келісім қайтарып алынды',
  'identity.consents.granted': 'Келісім тіркелді',
  'identity.consents.withdrawn': 'Келісім қайтарып алынды',
  'identity.consents.anonymizeConfirm': 'Клиенттің дербес деректерін дербессіздендіру керек пе?',
  'identity.consents.anonymizeWord': 'ДЕРБЕССІЗДЕНДІРУ',
  'identity.consents.anonymizeIrreversible':
    'Әрекет қайтымсыз: атын және телефонын қалпына келтіру мүмкін болмайды.',
  'identity.consents.effectPii': 'Аты, телефоны және байланыстары біржола жойылады',
  'identity.consents.effectLinks': 'Көліктермен байланыс жабылады, клиент сегменттерден шығады',
  'identity.consents.effectAudit': 'Әрекеттер журналында сіздің негіздемеңізбен жазба қалады',
  'identity.consents.history': 'Тарих',
  'identity.consents.version': 'Мәтін нұсқасы',
  'identity.consents.channel': 'Арна',
  'identity.consents.grantedAt': 'Берілген',
  'identity.consents.withdrawnAt': 'Қайтарылған',
  'identity.consents.marketingGate':
    'Күшіндегі маркетингтік келісімсіз клиент бірде-бір сегментке және таратуға кірмейді.',
  'identity.consents.anonymize': 'Келісімді қайтарып, дербестендірмеу',
  'identity.consents.anonymizeWarn':
    'Операция қайтымсыз. Дербес деректер жойылады, қаржы тарихы сақталады.',
  'identity.consents.anonymized': 'Клиент дербессіздендірілді',

  'identity.segments.title': 'Сегмент құрастырушы',
  'identity.segments.name': 'Атауы',
  'identity.segments.code': 'Коды',
  'identity.segments.mode': 'Жаңарту',
  'identity.segments.modeLive': 'Тірі',
  'identity.segments.modeScheduled': 'Кесте бойынша',
  'identity.segments.interval': 'Аралық, минут',
  'identity.segments.addRule': 'Шарт қосу',
  'identity.segments.addGroup': 'Топ қосу',
  'identity.segments.remove': 'Алып тастау',
  'identity.segments.match': 'Сәйкестік',
  'identity.segments.all': 'Барлық шарттар',
  'identity.segments.any': 'Кез келген шарт',
  'identity.segments.preview': 'Өлшемін көрсету',
  'identity.segments.size': 'Сегмент өлшемі: {n}',
  'identity.segments.save': 'Сегментті сақтау',
  'identity.segments.saved': 'Сегмент сақталды',
  'identity.segments.existing': 'Сақталған сегменттер',
  'identity.segments.refresh': 'Қайта жинау',
  'identity.segments.members': 'Құрамы',
  'identity.segments.asOf': 'Өзекті',
  'identity.segments.lastSize': 'Өлшемі',
  'identity.segments.edit': 'Өзгерту',
  'identity.segments.delete': 'Жою',
  'identity.segments.deleteTitle': '«{name}» сегментін жою керек пе?',
  'identity.segments.deleteBody': 'Сегмент мұрағатқа кетеді: ол қайта жиналмайды және жаңа таратуларға қатыспайды, таратулар тарихы сақталады.',
  'identity.segments.archived': 'мұрағатта',
  'identity.segments.editing': '«{name}» сегментін өңдеу',
  'identity.segments.cancelEdit': 'Өңдеуді болдырмау',
  'identity.segments.field': 'Өріс',
  'identity.segments.operator': 'Оператор',
  'identity.segments.value': 'Мәні',
  'identity.segments.window': 'Терезе, күн',
  'identity.segments.noCode':
    'Сегмент анықтамасы — код емес, дерек: өзгерту әзірлеушіні және шығаруды қажет етпейді.',

  'identity.segments.liveNoRefresh': 'әр сұрауда есептеледі',
  'identity.segments.memberName': 'Клиент',
  'identity.segments.memberPhone': 'Телефон',
  'identity.segments.memberVisits': 'Келу саны',
  'identity.segments.memberLastVisit': 'Соңғы келу',
  'identity.segments.memberTier': 'Деңгей',
  'identity.segments.memberNoName': 'Атауы жоқ',
  'identity.field.recency_days': 'Соңғы келуден бері күн',
  'identity.field.visit_count': 'Келу саны',
  'identity.field.paid_order_count': 'Төленген тапсырыс саны',
  'identity.field.monetary_minor': 'Сатып алу сомасы, ₸',
  'identity.field.avg_check_minor': 'Орташа чек, ₸',
  'identity.field.loyalty_balance_minor': 'Бонус балансы, ₸',
  'identity.field.lifetime_days': 'Тіркелгеннен бері күн',
  'identity.field.churn_risk_pct': 'Кету қаупі, %',
  'identity.field.customer_type': 'Клиент түрі',
  'identity.field.customer_source': 'Дереккөз',
  'identity.field.customer_status': 'Күйі',
  'identity.field.loyalty_tier_code': 'Адалдық деңгейі',
  'identity.field.vehicle_size_class': 'Көлік класы',
  'identity.field.vehicle_make': 'Көлік маркасы',
  'identity.field.visited_site_id': 'Нысанға келген',
  'identity.field.phone_verified': 'Телефон расталған',
  'identity.field.has_email': 'Поштасы бар',
  'identity.field.has_vehicle': 'Көлігі бар',
  'identity.field.has_visits': 'Келулері бар',
  'identity.field.display_name': 'Аты',

  'identity.op.eq': 'тең',
  'identity.op.ne': 'тең емес',
  'identity.op.lt': 'кіші',
  'identity.op.lte': 'кіші немесе тең',
  'identity.op.gt': 'үлкен',
  'identity.op.gte': 'үлкен немесе тең',
  'identity.op.in': 'кіреді',
  'identity.op.not_in': 'кірмейді',
  'identity.op.contains': 'қамтиды',
  'identity.op.starts_with': 'басталады',
  'identity.op.yes': 'иә',
  'identity.op.no': 'жоқ',

  'identity.common.cancel': 'Болдырмау',
  'identity.common.close': 'Жабу',
  'identity.common.loading': 'Жүктелуде…',
  'identity.common.nothing': 'Ештеңе табылмады',
  'identity.common.required': 'Міндетті өрістерді толтырыңыз',
  'identity.common.forbidden': 'Бұл бөлімге құқық жеткіліксіз',

};

export type IdentityKey = keyof typeof RU;
export type IdentityLocale = 'ru' | 'kk';

const DICTS: Readonly<Record<IdentityLocale, Record<IdentityKey, string>>> = { ru: RU, kk: KK };

export type IdentityTranslate = (
  key: IdentityKey,
  params?: Record<string, string | number>,
) => string;

export function makeIdentityT(locale: IdentityLocale): IdentityTranslate {
  const dict = DICTS[locale] ?? RU;
  return (key, params) => {
    const template = dict[key] ?? RU[key] ?? key;
    if (!params) return template;
    return template.replace(/\{(\w+)\}/g, (match, name: string) =>
      params[name] === undefined ? match : String(params[name]),
    );
  };
}

export function translateIdentityError(locale: IdentityLocale, code: string): string {
  const dict = DICTS[locale] ?? RU;
  return (dict as Record<string, string>)[`errors.${code}`] ?? code;
}
